<div class="flex justify-content-center p-0">
	<div class="p-col-12 p-md-6 p-lg-33 px-3 py-0">
		<div class="flex justify-content-center p-0">
			<div class="p-col-12 p-md-6 p-lg-3 p-0">
				<h3 class="first">{{ 'h3.screenDispatchingInvoicingTitle' | translate }}</h3>
			</div>
		</div>
		<div *ngIf="isMessage"class="flex justify-content-center p-0">
			<div class="p-col-12 p-md-6 p-lg-3 p-0">
				<h5 class="first"> {{message}} </h5>
			</div>
		</div>

		<div class="card pt-0">
			<load-info-display [showUser]="false" [routeCurrent]="routeCurrent"></load-info-display>
		</div>

		<!-- Esse componente está responsavel pela exibição de informações de caixa dentro da 420, por enquanto habilitado somente para exportação -->
		<!-- <ng-container *ngIf="receivingAndInvoicingResponseModel[0].exportacaoF == EXPORT_CASE_VALUE"> -->
		<ng-container *ngIf="dispAndInvoiResponse && dispAndInvoiResponse[0]  && dispAndInvoiResponse[0].exportacaoF == YES">
			<case-info-display [routeCurrent]="routeCurrent" [caseStatus]="dispAndInvoiResponse[0].statusTO" [case]="dispAndInvoiResponse[0].outboundCasesTO" [exportF]="dispAndInvoiResponse[0].exportacaoF" (successSaveCaseInfo)="receiveSuccessBoxEdition($event)" (editionModalClose)="focusCaseLabel()" (focusBackCase)="focusCaseLabel()"></case-info-display>
		</ng-container>

		<div class="pb-0 pt-2">
			<label>{{ 'label.caseLabelCode' | translate }}</label>
			<input type="number" pInputText inputmode="numeric"
				[ngClass]="{focusField: inputFields[0].focus}" tabindex="-1"
				[id]="inputFields[0].id"
				[(ngModel)]="inputFields[0].value"
				onkeydown="if(event.key==='.' || event.key==='-' || event.key==='+' || event.key==='e'){event.preventDefault();}"
				(keydown.enter)="checkCase()">
		</div>

		<div class="pb-0">
			<label>{{ 'label.typeCase' | translate }}</label>
			<input type="text" pInputText
				[ngClass]="{focusField: inputFields[1].focus}" tabindex="-1"
				[id]="inputFields[1].id" [disabled]="inputFields[1].disabled"
				[(ngModel)]="inputFields[1].value"
				(keydown.enter)="checkTypeCase()">
		</div>

		<div class="flex justify-content-center p-0">
			<div class="p-col-12 p-md-6 p-lg-3 p-0">
				<button
					class="submit" type="submit"
					(click)="dispatchAndInvoicing()" pButton
					label="{{ invoiceButtonLabel }}"
					[disabled]="buttonIsDisabled()"
					*resourceRequired="invoiceButtonResource">
				</button>
				<!-- TODO: Pensar em como trocar buttonIsDisabled() em uma variavel-->
			</div>
		</div>
	</div>
</div>

<!-- Transport Modal Selection p-dialog -->
<ng-container *ngIf="showExportChooseModal">
	<export-choose-modal
		[routeModal]="dispAndInvoiResponse[0].transportModalF"
		(onClose)="closeExportModal()"
		(onModalConfirmed)="closeModalAndInvoice($event)"
		(onModalError)="closeModalAndError($event)">
	</export-choose-modal>
</ng-container>

<input-generic
	[inputFields]="inputFields"
	(eventEmitter)="executeAction($event)">
</input-generic>

<alert-custom *ngIf="showAlert"
		(onCloseModal)="hideErrorModal($event)"
		[msg]="errorMessage"
		[elId]="errorFocus"
		[title]="errorTitle">
</alert-custom>

<p-confirmDialog header="Confirmation"></p-confirmDialog>
